"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createVisibilityVisitor = createVisibilityVisitor;
const renderingType_1 = require("../../../types/carrierQuestionnaire/renderingType");
const visibility_1 = require("./visibility");
function createVisibilityVisitor({ answersResolver, processOutput, complete, renderingType, timezone, currentDateOverride, }) {
    let isInHiddenSubtree = false;
    const enterHiddenSubtree = (callback) => {
        if (isInHiddenSubtree) {
            callback();
        }
        else {
            isInHiddenSubtree = true;
            callback();
            isInHiddenSubtree = false;
        }
    };
    const nodeVisitor = (options) => (navigation, { node, rule, repeatedInstanceIdentifiers }) => {
        let isVisible = !isInHiddenSubtree &&
            (0, visibility_1.evaluateVisibility)(node, renderingType ?? renderingType_1.RenderingType.web, answersResolver, repeatedInstanceIdentifiers, timezone, currentDateOverride, rule);
        if (!isVisible) {
            enterHiddenSubtree(() => navigation.visitChildren());
        }
        else {
            navigation.visitChildren();
            const shouldCheckChildVisibility = options?.hideIfChildrenHidden &&
                // dynamicOptions fields can be empty for reasons other than visibility. For consistency do not hide them even if empty.
                !node.dynamicOptions;
            if (shouldCheckChildVisibility) {
                const childrenEvaluation = navigation.childrenResults();
                if (childrenEvaluation.length !== 0 && childrenEvaluation.every(({ isVisible }) => !isVisible)) {
                    isVisible = false;
                }
            }
        }
        const out = {
            isVisible,
            repeatedInstanceIdentifiers,
            node,
            childrenVisibility: navigation.childrenResults(),
        };
        processOutput(out);
        return out;
    };
    return {
        visitDefault: nodeVisitor(),
        visitFieldGroup: nodeVisitor({ hideIfChildrenHidden: true }),
        visitField: nodeVisitor({ hideIfChildrenHidden: true }),
        complete,
    };
}
